import React from 'react'
import QuoteIcon from '../images/quote.svg'
import classNames from 'classnames'

interface IQuote {
  width?: string
  outside?: boolean
  className?: string
  icon?: React.ReactNode
  children: React.ReactNode
}

export const Quote: React.FC<IQuote> = (props) => {
  const icon = props.icon || <QuoteIcon className='onlinepbx__quote__icon' />
  return (
    <div className={classNames('onlinepbx__quote', {
      onlinepbx__quote__outside: !props.outside
    })}>
      {icon}
      <div style={{ maxWidth: `${props.width}px` }} className={classNames('onlinepbx__quote__text', props.className)}>
        {props.children}
      </div>
    </div>
  )
}

export default Quote
